import CancelIcon from "@mui/icons-material/Cancel";
import { Box, Drawer, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import ActionButton from "../FilterComponents/ActionButton";
import ByPartsFilter from "./ByPartsFilter";
import ByProductFilter from "./ByProductFilter";
import { useQualityData } from "../../context/QualityDataContext";
import { useSelectTagContext } from "../../context/SelectTagContext";
import ByFactorFilter from "./ByFactorFIlter";

const formattedDate = (dateString) => {
  const date = new Date(dateString);

  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

function FilterPanel({ handleClose, open, page, factorsData }) {
  const styles = {
    drawerPaper: {
      "& .MuiDrawer-paper": {
        borderRadius: "20px 0px 0px 20px",
      },
    },
    label: {
      fontWeight: 500,
      color: "#404040",
      fontSize: "13px",
    },
    formControl: {
      m: 1,
      minWidth: 120,
      borderRadius: "20px",
    },
    select: {
      borderRadius: "20px",
      height: "30px",
      width: "240px",
      // marginLeft: "7px",
    },
    valueBox: {
      borderRadius: "20px",
      border: "1px solid #E4E4E4",
      width: "84px",
      height: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#404040",
    },
    button: {
      width: "60px",
      height: "30px",
      borderRadius: "20px",
      textTransform: "capitalize",
      fontWeight: "500",
      fontSize: "13px",
      color: "white",
      marginRight: "8px",
    },
    title: {
      fontSize: "13px",
      fontWeight: "500",
      textTransform: "capitalize",
    },
    valueBoxStyle: { display: "flex", justifyContent: "space-between" },
  };

  const {
    selectedFilters,
    setSelectedFilters,
    appliedFilters,
    setAppliedFilters,
    setCancelFilters,
  } = useSelectTagContext();

  const applyFilters = () => {
    const filtersToApply = {
      partID: selectedFilters?.partID,
      partPrediction: selectedFilters?.prediction,
      partTimestamp: selectedFilters?.timestamp,
      productID: selectedFilters?.productID,
      productPrediction: selectedFilters?.prediction,
      productTimestamp: selectedFilters?.timestamp,
      factorsName: selectedFilters?.factorsName,
      fromTimestamp: formattedDate(selectedFilters?.fromTimestamp?.$d),
      toTimestamp: formattedDate(selectedFilters?.toTimestamp?.$d),
    };

    setAppliedFilters((prev) => ({
      ...prev,
      ...filtersToApply,
    }));

    localStorage.setItem("appliedFilters", JSON.stringify(filtersToApply));

    handleClose();
  };

  const clearFilters = () => {
    const clearedFilters = {
      partID: "",
      productID: "",
      prediction: "",
      timestamp: "",
      factorsName: "",
      fromTimestamp: "",
      toTimestamp: "",
    };
    setCancelFilters(true)

    setSelectedFilters(() => clearedFilters);

    localStorage.removeItem("appliedFilters");
  };

  // useEffect(() => {
  //   console.log("--> Selected Filters:", appliedFilters.fromTimestamp);
  // }, [appliedFilters]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      sx={styles.drawerPaper}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #E4E4E4",
          px: 2,
          py: 1,
        }}
      >
        <Typography sx={styles.title}>
          {/* {page === "company" ? "Client" : page} */}
          Filters Parts
        </Typography>
        <CancelIcon
          sx={{
            color: "#9F9F9F",
            cursor: "pointer",
            "&: hover": { color: "#FD5707" },
          }}
          onClick={handleClose}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            p: 2,
          }}
        >
          {page === "quality-By Parts" && <ByPartsFilter />}
          {page === "quality-By Products" && <ByProductFilter />}
          {page === "By Factors" && (
            <ByFactorFilter factorsData={factorsData} />
          )}
        </Box>
        <Box sx={{ ...styles.valueBoxStyle, p: 2, width: "350px" }}>
          <Box>
            <ActionButton
              label="Clear"
              color="#E98600"
              onClick={clearFilters}
            />
          </Box>
          <Box
            sx={{
              // flex: 2,
              display: "flex",
              justifyContent: "flex-end",
              gap: "25px",
            }}
          >
            <ActionButton
              label="Cancel"
              color="#9F9F9F"
              onClick={handleClose}
            />

            <ActionButton
              label="Apply"
              color="#0077B6"
              onClick={applyFilters}
            />
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
}

export default FilterPanel;
